var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10219",
    "data-name": "Group 10219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.583,
    height: 30.594,
    viewBox: "0 0 30.583 30.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2239",
    "data-name": "Rectangle 2239",
    width: 30.583,
    height: 30.594,
    fill: "#ffe800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10218",
    "data-name": "Group 10218",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27579",
    "data-name": "Path 27579",
    d: "M28.889,30.594a1.615,1.615,0,0,1-.939-.292L15.288,21.926,2.625,30.3A1.7,1.7,0,0,1,.172,28.132l13.6-27.2a1.7,1.7,0,0,1,3.029,0l13.6,27.2a1.7,1.7,0,0,1-.39,2.036,1.682,1.682,0,0,1-1.124.426m-13.6-12.416a1.782,1.782,0,0,1,.939.292l8.3,5.49L15.288,5.5,6.052,23.961l8.3-5.49a1.782,1.782,0,0,1,.939-.292",
    transform: "translate(0 0)",
    fill: "#ffe800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon16);
export default __webpack_public_path__ + "static/media/social_icon16.2887c08fd1d9ca1248b26b306eee9ed7.svg";
export { ForwardRef as ReactComponent };